import React from "react";

const loading = () => {
  return <div>Loading</div>;
};

export default loading;
